import React, { useRef, useState } from 'react';
import useClickOutside from '../../../../../common/hooks/useClickOutside';

import { IWidgetTitle } from '../../../types/IWidgetTitle';
import { Offset } from '@progress/kendo-react-popup';

import ContextMenuWidget from './contextMenuWidget';
import CustomisationRibbon from './customisationRibbon';
import WidgetCommands from './widgetCommands';
import Notes from './notes';

import './widgetTitle.scss';

const WidgetTitle: React.FC<IWidgetTitle> = ({
                                               name,
                                               type,
                                               currencySelection,
                                               selectedCurrency,
                                               handleCurrencyChange,
                                               onClick,
                                               expand,
                                               onCollapse,
                                               onExpand,
                                               notes,
                                               setGridView,
                                               gridView,
                                               localCurr,
                                               onImageExportClick,
                                               onPDFExportClick,
                                               onSVGExportClick,
                                               excelExport,
                                               id,
                                               customisation,
                                               widgets,
                                               handleWidgetChange,
                                               handleWidgetMove,
                                               changeOldIndex,
                                               changeNewIndex,
                                               widget,
                                               selectedObject,
                                               homePage,
                                               investorId,
                                               handleUnpin,
                                               handlePinWidget,
                                               handleUnpinWidget,
                                               unpinId,
                                             }) => {
  const [notesShown, setNotesShown] = useState<boolean>(false);
  const [popup, setPopup] = useState<boolean>(false);
  const [position, setPosition] = useState<Offset>({ left: 0, top: 0 });

  const notesWrapperRef = useRef<HTMLDivElement>(null);
  const menuWrapperRef = useRef<HTMLDivElement>(null);

  const toggleNotes = () => {
    setNotesShown(!notesShown);
  };

  const clickOutsideHandlerNotes = () => {
    setNotesShown(false);
  };

  const clickOutsideHandlerMenu = () => {
    setPopup(false);
  };

  useClickOutside(notesWrapperRef, clickOutsideHandlerNotes, 'notes-widget-icon');
  useClickOutside(menuWrapperRef, clickOutsideHandlerMenu, 'series-click-button');

  return (
    <>
      <div className={'widget-title'}>
        <Notes
          //@ts-ignore
          currencyName={selectedCurrency.currencyShortName}
          //@ts-ignore
          currencySymbol={selectedCurrency.currencySymbol}
          notes={notes} name={name} notesShown={notesShown} toggleNotes={toggleNotes}
          currencySelection={currencySelection}
          handleCurrencyChange={handleCurrencyChange}
          selectedCurrency={selectedCurrency}
          selectedObject={selectedObject}
          localCurr={localCurr}
          widget={widget}
          homePage={homePage}
          investorId={investorId}
          type={type}
          ref={notesWrapperRef} />

        {customisation ? <CustomisationRibbon id={id} widgets={widgets} handleWidgetMove={handleWidgetMove}
                                              changeNewIndex={changeNewIndex} changeOldIndex={changeOldIndex}
                                              handleWidgetChange={handleWidgetChange} homePage={homePage} /> : null}

        <WidgetCommands
          type={type}
          setPopup={setPopup}
          setPosition={setPosition}
          expand={expand}
          popup={popup}
          onClick={onClick}
          onCollapse={onCollapse}
          onExpand={onExpand}
          widget={widget}
          selectedObject={selectedObject}
          homePage={homePage}
          handleUnpin={handleUnpin}
          handlePinCallback={handlePinWidget}
          handleUnpinFromBoardCallback={handleUnpinWidget}
          unpinId={unpinId}
        />
      </div>
      {type === 'chart' && (
        <div ref={menuWrapperRef}>
          <ContextMenuWidget
            offset={position}
            show={popup}
            popupClass={'popup-content'}
            className={'popup-wrapper'}
            animate={false}
            setGridView={setGridView}
            gridView={gridView}
            excelExport={excelExport}
            onSVGExportClick={onSVGExportClick}
            onImageExportClick={onImageExportClick}
            onPDFExportClick={onPDFExportClick}
            widget={widget}
            selectedObject={selectedObject}
          />
        </div>
      )}
    </>
  );
};

export default WidgetTitle;
